import { useRef, useState } from "react";
import { Button, Input } from "../../elements";
import styles from './DeleteAccountPage.module.scss';
import { toast } from "react-toastify";
import { app } from "../../../application";

export function DeleteAccountPage() {

    const [isLoading, setIsLoading] = useState<boolean>(false);

     const credentials = useRef({
    email: '',
    password: '',
  });

  const usernameRef = useRef<HTMLInputElement>(null);
  const passwordRef = useRef<HTMLInputElement>(null);

  const handleSubmit = async (e: React.FormEvent) => {
   e.preventDefault();

   if (!credentials.current.email || !credentials.current.password) {
    toast.error('Please fill in all fields');
    return;
   } else if (credentials.current.email.length < 4) {
    toast.error('Invalid username!');
    return;
   } else if (credentials.current.password.length < 8) {
    toast.error('Invalid password!');
    return;
   }

   try {
    setIsLoading(true);
     await app().userService.login(
      {
        email: credentials.current.email,
        password: credentials.current.password  
      });
    
      if (window.confirm(`Are you sure you want to delete your account?
       This action cannot be undone.`)) {
        await app().userService.deleteAccount();
      }
   
      credentials.current.email = '';
      credentials.current.password = '';
      usernameRef.current!.value = '';
      passwordRef.current!.value = '';
      toast.error('Your account has been deleted!');
   } catch (error) {
    toast.error('Authentication failed!');
   } finally {
    setIsLoading(false);
   }
 };

 const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    credentials.current[e.target.name as keyof typeof credentials.current] = e.target.value;
 };



    return (
        <div className={styles.deleteAccountPage}>
            <div className={styles.deleteAccountPageForm}>
            <div className={styles.logo}/>
                <Input
                    ref={usernameRef}
                    label="Email" 
                    placeholder="Email" 
                    type="email" 
                    name="email"
                    id="email" 
                    onChange={handleChange}
                />
                <Input
                    ref={passwordRef}
                    label="Password"
                    placeholder="Password"
                    type="password"
                    name="password"
                    id="password" 
                    onChange={handleChange}
                />
                <Button
                    theme="Danger"
                    isLoading={isLoading}
                    onClick={handleSubmit}>Delete Account</Button>
            </div>

        </div>
    )
}
